import { Component, OnInit, Inject, PLATFORM_ID, HostListener, ElementRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var $: any;
declare const sourceMediumData: any;

import * as $ from 'jquery';
// import * as AOS from 'aos';
import { WINDOW } from '@ng-toolkit/universal';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  notSticky: boolean = false;
  isMenuActive: boolean = false;
  isBackdropActive: boolean = false;
  isMegaOpen = false;
  
  constructor(
    @Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: Object,
    public loadScript: LoadScriptService,
    private el: ElementRef,
    private router: Router
  ) {
    
  }


  openMega() {
    this.isMegaOpen = true;
  }

  closeMega() {
    this.isMegaOpen = false;
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      $(".dropdown-toggle").hover(function(){
        $('.dropdown-menu').css("opacity", "1");
        $('.dropdown-menu').css("visibility", "visible");
      });
      $('.navbar-nav a').click(function(){
        $('.dropdown-menu').css("opacity", "0");
        $('.dropdown-menu').css("visibility", "hidden");
      });
      $(document).on('click', '.navbar-nav a', function (e) {
        e.stopPropagation(); // stop Bootstrap’s dropdown from auto-closing
      });
    }
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      this.closeMega();
    });
  }

  closeCanvasMenu() {
    this.isBackdropActive = false;
    this.activeDropdown = null;
    const offCanvasMenu = document.querySelector('.navbar-collapse.offcanvas');
    if (offCanvasMenu) {
      offCanvasMenu.classList.add('hiding');
      setTimeout(() => {
        this.isMenuActive = false;
        offCanvasMenu.classList.remove('hiding', 'show');
      }, 300);
    }
  }
  
  toggleOffCanvasMenu() {
    const offCanvasMenu = document.querySelector('.navbar-collapse.offcanvas');
    this.isBackdropActive = true;
    if (!this.isMenuActive) {
      offCanvasMenu?.classList.add('showing');
      setTimeout(() => {
        this.isMenuActive = true;
        offCanvasMenu?.classList.remove('showing');
        offCanvasMenu?.classList.add('show');
      }, 300);
    } else {
      this.closeCanvasMenu();
    }
  }

  toggleClass(event: Event): void {
    const allPTags = document.querySelectorAll('.nav-link.dropdown-toggle');
    
    // Remove 'show' class from all <p> tags
    allPTags.forEach((pTag) => {
      pTag.classList.remove('show');
    });
  
    // Add 'show' class to the clicked <p> tag
    const clickedPTag = event.target as HTMLElement;
    clickedPTag.classList.toggle('show');
  }

  activeDropdown: string | null = null;

  toggleDropdown(key: string): void {
    this.activeDropdown = this.activeDropdown === key ? null : key;
  }

  @HostListener('window:scroll')
  checkScroll() {
    this.notSticky = window.pageYOffset >= 100;
  }

  // generateLinkWithSourceMedium(isSignupLink: boolean = true): string {
  //   const currentPath = this.router.url.split('?')[0];
  
  //   const isConfidentialPage =
  //     currentPath === '/enterprise/confidential-data-plan-for-grammar-checker';
  
  //   let baseUrl = '';
  
  //   if (isSignupLink) {
  //     baseUrl = isConfidentialPage
  //       ? 'https://cloud.trinka.ai/cdp-signup'
  //       : 'https://cloud.trinka.ai/signup';
  //   } else {
  //     baseUrl = 'https://cloud.trinka.ai/signin';
  //   }
  
  //   const params = new URLSearchParams();
  //   params.set('_rg', 'GB');
  
  //   try {
  //     if (sourceMediumData?.source) {
  //       params.set('source', sourceMediumData.source);
  //     }
  
  //     if (sourceMediumData?.medium) {
  //       params.set('medium', sourceMediumData.medium);
  //     }
  //   } catch (error) {
  //     params.set('source', '');
  //     params.set('medium', '');
  //   }
  
  //   const redirectLink = `${baseUrl}?${params.toString()}`;
  
  //   return redirectLink;
  // }

  generateLinkWithSourceMedium(isSignupLink: boolean = true): string {
    const currentPath = this.router.url.split('?')[0];
  
    const isConfidentialPage =
      currentPath === '/enterprise/confidential-data-plan-for-grammar-checker';
  
    const isPricingCdpPage =
      currentPath === '/pricing-plans-cdp';
  
    // const isGrammarCheckerPage =
    //   currentPath === '/grammar-checker';
  
    // const isParaphraserPage =
    //   currentPath === '/paraphrasing-tool';
  
    // const isConsistencyPage =
    //   currentPath === '/features/consistency-check';
  
    let baseUrl = '';
    const params = new URLSearchParams();
  
    if (isSignupLink) {
      if (isConfidentialPage) {
        baseUrl = `${environment.trinkaCloudUrl}/cdp-signup`;
      } else {
        baseUrl = `${environment.trinkaCloudUrl}/signup`;
  
        // const redirect = isConsistencyPage
        //   ? 'consistency'
        //   : isParaphraserPage
        //     ? 'paraphraser'
        //     : isGrammarCheckerPage
        //       ? 'grammar'
        //       : '';
  
        // if (redirect) {
        //   params.set('redirect', redirect);
        // }
      }
    } else {
      baseUrl = `${environment.trinkaCloudUrl}/signin`;
    }
  
    params.set('_rg', 'GB');
  
    try {
      if (sourceMediumData?.source) {
        params.set('source', sourceMediumData.source);
      }
  
      if (sourceMediumData?.medium) {
        params.set('medium', sourceMediumData.medium);
      }
    } catch (error) {
      params.set('source', '');
      params.set('medium', '');
    }
  
    // Add UTM params only for CDP pricing page
    if (isPricingCdpPage) {
      params.set('utm_source', 'cdp_plag_check');
      params.set('utm_medium', 'website');
      params.set('utm_id', isSignupLink ? 'start_for_free' : 'login');
    }
  
    return `${baseUrl}?${params.toString()}`;
  }


  hideLoginButtons(): boolean {
    return this.router.url.includes('/pricing-plans-cdp-aid');
  }
}
